// Japanese

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `締切日: ${date}` : ''),
    },
    interview: {
      title: 'ビデオ面接に応募してください。',
      submit: '回答を送ることで、面接を完了してください。',
      continueLater: '後で再開する',
      startInterview: '面接を開始する',
      duplicateError: 'あなたはこの面接に既に参加されています。invitations@recright.comより、面接を再開するためのリンクをEメール致しました。',
      confirmSubmit: '全ての面接設問への回答を完了していません。本当に面接をここで終了されますか？その場合、回答を完了することがで不可能となります。',
      confirmSubmitHeader: '回答漏れがあります。面接の質問すべてにお答えください。',
      confirmSubmitContent: '面接を終了するのですね？',
      confirmSubmitContentWarning: '終了後は、質問に対する回答を完了できなくなります。',
      submitInterviewHeader: '面接の回答を提出する',
      submitInterviewContent: '本当に面接を提出しますか？',
      confirmSubmitButton: '回答を送り面接を完了する',
      preview: 'ビデオ設問のプレビューはこちらから',
      withdrawLink: 'この職種に興味がなくなりましたか？ 手続きからの辞退はこちら',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'お名前',
      email: 'Eメール',
      phone: '電話番号',
      city: '居住都市',
      link: 'リンク',
      legendBasicInfo: '基本情報',
      placeholderName: 'お名前を入力してください。',
      placeholderEmail: 'Eメールを入力してください。',
      placeholderPhone: '電話番号を入力してください。',
      placeholderCity: '現在の居住都市を入力してください。',
      placeholderLink: 'LinkedInプロフィール等、参照リンクを入力してください。',
      legendAttachments: '添付ファイル',
      legendAdditionalFields: '追加情報',
      required: '*マークが付いた項目は必須入力です。',
    },

    sequencedInterview: {
      networkTest: {
        audio: '音声',
        video: '映像',
        yes: 'はい',
        no: 'いいえ',
        supported: '対応する',
        quality: '品質',
        header: 'ネットワーク接続とデバイスのテスト',
        description: 'ここで、面接に必要なネットワークの接続とハードウェア（カメラと電話）が、正しく機能することを確認するテストを行います。テストのプロンプトが表示されたら、カメラとマイクの両方を使用できる状態にし、カメラのレンズがカバーでふさがっていないことを確認してください。テストは約30秒かかります。ハードウェアのテスト中に話しかけてみてください。',
        inProgress: 'テスト中...',
        networkTestResults: 'ネットワークテストの結果',
        qualityTestResults: '品質テスト結果',
        testPassedQuality: '品質テスト合格',
        testFailedQuality: '品質テスト不合格',
        testPassedNetwork: 'ネットワークテスト合格',
        testFailedNetwork: 'ネットワークテスト不合格',
        startTest: 'テストを始める',
        startInterview: '面接を始める',
        testAgain: '再度テストをする',
        confirmWarning: 'ビデオ面接が始まると、画面に最初の設問が自動で表示されます。設問を読み、回答を準備してください。',
        confirmTitle: 'これから面接が始まります',
        confirmText: '各設問に回答する前に、回答を準備する時間が少しあります。準備ができたら、決められた時間内に設問に答えてください。(注 所定時間に満たなくても回答が終われば、送信してかまいません。',
        confirmText2: '回答を送信したら次の質問に移動します。同じ作業が、最後の質問への回答を送信するまで続きます。',
        confirmText3:
          '質問に対する回答をやり直した後、その質問へのやり直しが許可されていれば、回答をやり直すための30秒間のウインドウが表示されます。この30秒以内にやり直しを開始しない場合、現在の回答が自動的に提出され、次の問題に進みます。',
        goodLuck: '深呼吸して落ち着きましょう。大丈夫ですよ！',
        qualityRating: {
          excellent: '優良',
          good: '良い',
          fair: '普通',
          poor: '不十分',
          bad: '悪い',
        },
      },
      questionAnswerView: {
        title: title => `面接${title}への回答`,
        question: '質問',
        submitAndNext: '提出して次へ',
        submitSuccess: '無事に動画を提出できました！',
        skipText: '録画の開始',
        stop: '停止',
        submitAndFinish: '送信して面接を終了',
        retake: '撮り直す',
        take: '撮影する',
        takesLeft: '残り撮影回数',
        skipTextQuestion: '準備はできた?じゃ、進めよう',
        retakeConfirmTitle: 'この質問への回答をやり直しますか？',
        retakeConfirmSubmit: 'はい、これからやり直します',
        submitInfoForward: '現在の回答を自動的に提出し、次に進んでください',
        submitInfoForward2: '秒',
        nonAnswerableText: 'このメッセージへの回答は不要です。このメッセージのあと、次の質問に直接移動します。',
        nonAnswerableVideo: 'このメッセージへの回答は不要です。このビデオのあと、次の質問に直接移動します。',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `${answerMinutes} 分と ${answerSeconds} 秒以内に質問に答えてください。`,
      },
      publisher: {
        toNextQuestion: timer => `${timer}で次の質問に移動します。`,
        recordingStarts: timer => `${timer}で録画が始まります。`,
      },
      errors: {
        tooManyConnections: 'この接続は、あなたがほかのタブやウィンドウですでに接続されているため閉じられました。',
        unsupportedBrowser: '申し訳ございません。お使いのブラウザは、この操作に対応していません。別のブラウザをお使いください。',
        networkError: 'インターネットに接続されていません。',
        reconnecting: 'インターネット接続が中断しました。もう一度接続してください。',
        generalError: '問題が発生しました。, ページを更新して、もう一度試してください。',
        allowMediaDevicesError: 'この操作はメディア デバイス（カメラまたはマイク）の取得に失敗しました。ブラウザが、お使いのカメラまたはマイクの使用を許可していることを確認してください。',
        noAvailableDevicesError: 'カメラまたはマイクが見つかりません。',
        initPublisherError: 'エラーのため、作業に失敗しました。ブラウザで、カメラとマイクが使用が許可されていること、また別のアプリケーションで使用されていないかどうかを確認してから、もう一度お試しください。',
      },
      browserInfo: {
        browserSupportTitle: 'ブラウザの対応',
        supportedBrowsers: 'このテストと面接は、最新のChrome、Firefox、SafariおよびEdgeに対応しています。',
        mobileSupported: '携帯端末の対応ブラウザ',
        android: 'Android: Google Chrome（最新バージョン）、Firefox（最新バージョン）',
        iOS: 'iOS: Safari（最新バージョン）',
        latestVersion: 'ブラウザは必ず最新バージョンをお使いください。これにより操作がスムーズに行えます。',
        freezeInstruction: '録画が開始しない、または録画の画面が黒いままの場合は、ページを更新してください。',
        unsupportedOnIos: 'iOSに対応していないブラウザが使われているようです。Safariをお使いください。',
        ieUnsupported: 'Internet Explorerをお使いのようです。申し訳ございません。Internet Explorerは、このテストや面接には対応していません。別のブラウザをお使いください。',
        qualityTestNotSupported: '申し訳ございません。お使いのブラウザは、ハードウェアのテストに対応していません。音声と映像の品質をテストせずに面接を続けるか、別のブラウザを使用してください。',
      },
      reconnectSuccess: '無事に再接続できました！',
      continue: '続ける',
    },

    withdraw: {
      title: 'この職種に興味がなくなりましたか？',
      description: '採用手続きから辞退する。',
      buttonText: '採用手続きから辞退',
      thankYouTitle: 'ご依頼を確認しました!',
      thankYouText: '採用担当者に、この職種への応募を辞退したことをお伝えしました。',
      confirm: '本当に採用続きから辞退するのですね？ 辞退すると、以降はこの職種や関連職種へ応募したり面接を受けたりできなくなります。',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: '提出する',
      continue: '続ける',
      supportCenter: 'Recright Help Center',
      thankYou:
        'ビデオ面接へのご参加ありがとうございました！弊社より早々にご連絡致します。',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: '面接にご参加いただき、ありがとうございます！',
      reopenDescription: '誤ってインタビューを終了しましたか。ご心配なく！下のボタンをクリックすれば再開できます！',
      reopenButtonText: 'インタビューを再開する',
      description1: '全てのビデオ設問に回答が完了し、提出されました。',
      descriptionsupport: mailto => `何らかの不具合や不測の事態によりこの面接を閉じてしまった場合は、本プラットフォームのカスタマーサービス ${mailto} までご連絡ください。あなたの面接を再稼働させるお手伝いをいたします。`,
      descriptionfeedback: 'ビデオ面接はいかがだったでしょうか？あなたの体験とご意見を私たちはとても重要視しています。是非ご感想や、より良いビデオ面接体験をご提供するために私たちが改善すべき点等のフィードバックをお気軽にお寄せください。',
      feedbackbutton: '意見・感想をフィードバックする',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'パーソナル・メッセージ',
    },

    closed: {
      title: '本面接は終了いたしました。',
      description: 'あなたにご案内しておりましたビデオ面接は既に終了、もしくは提出済です。',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'あなたのビデオ面接は保存されました！',
      description: 'ビデオ面接を再開されたい場合は、以前に受信されたEメール記載のリンクをご利用ください。既に録画保存されたビデオ面接内容を再開時にご確認いただけます。ご健闘をお祈りしております！',
      remember: 'ビデオ面接への回答を完了したら、採用チームに提出することをお忘れなきようお願いいたします。',
      deleteHistory: '公共・共有のコンピューターやデバイスでビデオ面接に参加された場合は、ビデオ面接終了後にブラウザーのアクセス履歴を消去しておきましょう。これによりあなたの面接内容が脅かされることがなくなります。',
    },
    unpublished: {
      title: '面接はまだ始まっていません',
      publishTime: publishTime => `面接は${publishTime}に始まります`,
    },
  },
}
